module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-visitor-ui": "static-1.28763",
      "ably": "static-2.2",
      "data-fetching-client": "static-1.9572",
      "ably-hubspot-js": "static-2.4611",
      "atom": "static-1.4968",
      "conversations-async-data": "static-2.7562",
      "conversations-error-reporting": "static-1.8775",
      "conversations-internal-pub-sub": "static-1.15866",
      "conversations-internal-schema": "static-1.12666",
      "conversations-message-history": "static-1.12361",
      "conversations-test-sdk": "static-1.10397",
      "conversations-visitor-experience-components": "static-1.22126",
      "head-dlb": "static-1.4921",
      "hs-promise-utils": "static-1.5491",
      "hs-test-utils": "static-1.7908",
      "hubspot-dlb": "static-2.1828",
      "HubStyleTokens": "static-2.11349",
      "I18n": "static-7.1602",
      "immer": "static-1.33",
      "jasmine-immutable": "static-1.2914",
      "jasmine-runner": "static-1.6366",
      "quartz": "static-1.6864",
      "react-dlb": "static-1.76",
      "react-select-plus": "static-1.65",
      "react-transition-group": "static-2.63",
      "redux-thunk": "static-2.43",
      "sanitize": "static-1.4370",
      "StyleGuideUI": "static-3.485",
      "transmute": "static-2.85",
      "urlinator": "static-1.4429",
      "usage-tracker": "static-1.7233",
      "usage-tracker-core": "static-1.7083",
      "usage-tracker-public": "static-1.7044",
      "viral-links-lib": "static-1.6938",
      "visitor-ui-component-library": "static-1.6033",
      "webpack-env": "static-1.54",
      "autolinker": "static-3.11",
      "classnames": "static-2.10",
      "conversations-http": "static-1.4705",
      "conversations-prop-types": "static-1.7350",
      "conversations-visitor-message-history": "static-1.20863",
      "cssUtils": "static-1.768",
      "enviro": "static-4.425",
      "flux-actions": "static-1.325",
      "foundations-components": "static-1.7717",
      "hs-lodash": "static-4.45",
      "hub-http": "static-1.6116",
      "hubspot-url-utils": "static-1.4034",
      "immutable": "static-2.76",
      "metrics-js": "static-1.9522",
      "PatternValidationJS": "static-1.437",
      "PortalIdParser": "static-2.386",
      "raven": "static-3.5808",
      "react": "static-7.184",
      "react-aria": "static-1.64",
      "react-dom": "static-7.85",
      "react-redux": "static-7.69",
      "react-rhumb": "static-1.16552",
      "react-utils": "static-2.5264",
      "redux": "static-4.16",
      "redux-toolkit": "static-1.7",
      "reselect": "static-2.16",
      "sanitize-text": "static-1.8042",
      "signup-constants": "static-1.18652",
      "styled-components": "static-2.87",
      "usage-tracker-multi": "static-1.5647",
      "visitor-ui-component-library-icons": "static-1.5844",
      "hs-promise-rejection-tracking": "static-1.5473",
      "raven-hubspot": "static-1.6115",
      "hoist-non-react-statics": "static-3.9",
      "bend-plugin-trellis-migration": "static-1.3322",
      "moment": "static-3.26",
      "apollo-stack-hubspot": "static-3.84",
      "fast-json-stable-stringify": "static-1.4",
      "graphql": "static-1.80",
      "quartz-config": "static-1.642",
      "quartz-core": "static-1.6083",
      "react-immutable-proptypes": "static-2.8",
      "foundations-assets": "static-1.4744",
      "foundations-theming": "static-1.4310",
      "UIComponents": "static-3.8296",
      "customer-data-email": "static-1.17853",
      "cv-backend-services": "static-1.1537",
      "immutable-less": "static-1.4550",
      "conversations-skeleton-state": "static-1.7146",
      "crm-events-viz-core": "static-1.32830",
      "customer-data-objects": "static-1.7553",
      "icons": "static-2.639",
      "react-input-autosize": "static-2.17",
      "rpc-client-utils": "static-1.4541",
      "ui-images": "static-2.1128",
      "HeadJS": "static-2.735",
      "framer-motion": "static-1.70",
      "hs-test-utils-bend-plugin": "static-1.3019",
      "msw": "static-1.39",
      "testing-library": "static-1.150",
      "i18n-data": "static-1.219",
      "moment-timezone": "static-5.81",
      "jasmine": "static-4.4221",
      "signup-ui-url-generator": "static-2.7938",
      "HubStyle": "static-2.11657",
      "quartz-i18n": "static-1.539",
      "sassPrefix": "static-1.154",
      "bend-plugin-foundations-components": "static-1.3986",
      "floating-ui": "static-1.54",
      "foundations-theming-specialty": "static-1.2026",
      "hs-story-utils": "static-1.9327",
      "react-virtualized": "static-2.97",
      "tanstack-table": "static-1.53",
      "trellis-assets": "static-1.1523",
      "ui-fonts": "static-1.611",
      "csstype": "static-1.50",
      "quick-fetch": "static-1.3832",
      "history": "static-4.47",
      "usage-tracker-anonymous": "static-1.5650",
      "bender-build-tools": "static-1.3063",
      "dispatcher": "static-1.134",
      "general-store": "static-6.20",
      "hub-http-janus": "static-1.819",
      "hubspotter-http": "static-1.4568",
      "mobile-manifest-mixins": "static-1.508",
      "module-federation": "static-1.21",
      "quartz-auth": "static-1.539",
      "quartz-head": "static-1.529",
      "quartz-routing": "static-1.294",
      "quartz-test": "static-1.539",
      "quartz-tracking": "static-1.243",
      "usage-tracker-container": "static-1.7223",
      "bend-plugin-foundations-theming": "static-1.2793",
      "foundations-theming-base": "static-1.3295",
      "stylex": "static-1.30",
      "apollo-dlb": "static-3.80",
      "apollo-link-hub-http": "static-2.4548",
      "customer-data-ui-utilities": "static-1.9722",
      "FileManagerCore": "static-1.38788",
      "FileManagerLib": "static-1.38929",
      "hubspot-apollo-client": "static-1.4775",
      "react-immutable-render-mixin": "static-1.9",
      "salesImages": "static-1.523",
      "timezone-utils": "static-2.5141",
      "ui-gdpr-components": "static-1.10245",
      "ts-schema": "static-1.3994",
      "ai-components-ui-library": "static-1.8674",
      "avatar-components": "static-1.2391",
      "content-assistance-lib": "static-1.7598",
      "crm-component-utils": "static-1.38783",
      "crm-display-components": "static-1.24533",
      "crm-fe-perf": "static-1.22800",
      "crm-links": "static-1.6172",
      "crm-message-bus": "static-1.42694",
      "crm-search-service-types": "static-1.1048",
      "crm-source-interpretation-lib": "static-1.5231",
      "customer-data-communicator": "static-1.45203",
      "customer-data-filters-ui": "static-1.39347",
      "customer-data-objects-ui-components": "static-1.12915",
      "customer-data-properties": "static-1.51179",
      "customer-data-rte": "static-1.32726",
      "draft-plugins": "static-2.21492",
      "file-manager-components": "static-1.23289",
      "framework-data-schema-resolvers": "static-1.6772",
      "frontend-preferences-client": "static-1.7821",
      "hubspot-prosemirror": "static-1.17936",
      "object-comments-thread-lib": "static-1.10381",
      "reference-resolvers-lite": "static-1.7986",
      "ui-addon-upgrades": "static-9.17839",
      "universal-associations-select": "static-1.10906",
      "universal-record-utils-lib": "static-1.568",
      "inbound-db-properties-service-client": "static-1.3762",
      "property-translator": "static-1.5305",
      "chirp-fetch": "static-1.1778",
      "hub-http-shared-msw-handlers": "static-1.9725",
      "hubspotter-http-shared-msw-handlers": "static-1.9723",
      "react-router-dom": "static-5.26",
      "usage-tracker-session-replay": "static-1.4919",
      "react-dnd-compat": "static-1.4515",
      "audio-components": "static-1.5760",
      "cropperjs": "static-1.10",
      "feedback-loader": "static-1.29103",
      "FileManagerImages": "static-1.36440",
      "foundations-components-legacy": "static-1.742",
      "immerable": "static-1.4050",
      "ui-universal-auth": "static-1.8831",
      "video-components": "static-1.12943",
      "video-data-lib": "static-1.34598",
      "video-embed": "static-1.35432",
      "hubspot-apollo-cache": "static-1.234",
      "chatspot-core": "static-1.20799",
      "ContentUtils": "static-1.68035",
      "copilot-toolkit": "static-1.10837",
      "superstore": "static-1.4666",
      "ui-addon-video-player": "static-1.8593",
      "ui-coaching-tips": "static-1.28249",
      "card-properties-lib": "static-1.43858",
      "commerce-subscription-lib": "static-1.36793",
      "crm-actions": "static-1.6211",
      "crm-cards-sdk": "static-1.43266",
      "customer-data-properties-shared-msw-handlers": "static-1.9052",
      "customer-data-property-utils": "static-1.7980",
      "customer-data-tracking": "static-1.6781",
      "hs-resources": "static-1.35",
      "inbound-db-meta-service-client": "static-1.3505",
      "pulse": "static-1.437",
      "framework-data-table": "static-2.11673",
      "location-customization-utils-lib": "static-1.8912",
      "calling-error-reporting": "static-1.31204",
      "calling-internal-common": "static-1.31198",
      "calling-usage-tracker": "static-1.6438",
      "crm_data": "static-4.91623",
      "customer-data-content": "static-1.27085",
      "draft-content-plugins": "static-1.27993",
      "draft-convert": "static-2.71",
      "draft-extend": "static-3.73",
      "draft-js": "static-5.76",
      "draft-signature-plugin": "static-1.23795",
      "EmailSignatureEditor": "static-1.24146",
      "hubspot-prosemirror-plugins": "static-1.17928",
      "integration-settings-components": "static-1.15152",
      "integrations-lib": "static-1.15776",
      "integrations-tracking-lib": "static-1.5492",
      "native-integrations-shared-strings": "static-1.7683",
      "nav-meta": "static-1.29281",
      "onboarding-scopes": "static-1.6361",
      "outreach-assistant-email-generation": "static-1.6010",
      "prosemirror": "static-1.13",
      "quotes-client-types": "static-1.37686",
      "react-colorpicker": "static-2.10106",
      "reference-resolvers": "static-1.8064",
      "rich-text-lib": "static-1.19652",
      "sales-email-signature-service-client": "static-1.3740",
      "sequences-lib": "static-1.7862",
      "ui-addon-i18n": "static-1.11044",
      "ui-addon-iframeable": "static-1.8946",
      "ui-business-units-lib": "static-1.8937",
      "ui-shepherd-react": "static-3.10044",
      "user-context": "static-1.4997",
      "whatsapp-sending-lib": "static-1.5321",
      "customer-data-filters-ui-msw-helpers": "static-1.21782",
      "customer-data-reference-ui-components": "static-1.13050",
      "FormUrlGenerator": "static-2.4616",
      "framework-builder-read-service-client": "static-1.3924",
      "framework-data-schema-quick-fetch": "static-1.6677",
      "multi-account-reference-resolvers": "static-1.873",
      "onboarding-tours": "static-1.16413",
      "reporting-datasets-permissions-lib": "static-1.13378",
      "SharedI18nStrings": "static-1.181",
      "ui-addon-teams": "static-1.21407",
      "calling-global-api": "static-1.64094",
      "calling-lifecycle-internal": "static-1.65476",
      "calling-lifecycle-messages": "static-1.57770",
      "commerce-products-lib": "static-1.9149",
      "conditional-properties-service-client": "static-1.3713",
      "external-options-client-types": "static-1.4074",
      "google-libphonenumber": "static-1.36",
      "inbounddb-objects-service-types": "static-1.4139",
      "meetings-icalendar-utils-lib": "static-1.527",
      "multi-currency-client-types": "static-1.3606",
      "object-builder-ui-client": "static-1.48387",
      "pipeline-validation-client-types": "static-1.3881",
      "property-value-citations": "static-1.1793",
      "smart-property-lib": "static-1.6426",
      "tiered-pricing": "static-1.1009",
      "ui-addon-form-validation": "static-1.10888",
      "video-components-external": "static-1.10940",
      "batch-promise": "static-1.1449",
      "crm-pipelines-api-client-types": "static-1.4058",
      "persist-promise": "static-1.3606",
      "emoji-mart": "static-3.4",
      "growth-payments-core": "static-1.25054",
      "knowledge-content-types": "static-1.8441",
      "payment-link-components": "static-1.23237",
      "ui-addon-emoji-picker": "static-1.9784",
      "call-summary": "static-1.38784",
      "reference-resolvers-lite-shared-msw-handlers": "static-1.9871",
      "laboratory-lib": "static-3.7056",
      "merchandise-lib": "static-1.261",
      "purchase-motions-components": "static-1.5677",
      "crm-object-search-query-utilities": "static-1.9340",
      "amplitude-session-replay-browser": "static-1.58",
      "react-dnd": "static-5.6",
      "react-dnd-html5-backend": "static-5.6",
      "unified-auth-core-lib": "static-1.626",
      "content-icons-ui": "static-1.2201",
      "social-insights-client-types": "static-1.21775",
      "outpost": "static-1.4092",
      "markdown-it": "static-1.6",
      "cms-field-types": "static-1.4706",
      "underscore": "static-1.8",
      "magpie-lib": "static-1.5490",
      "magpie-types": "static-1.4950",
      "simple-logging-lib": "static-1.2948",
      "growth-onboarding-feedback-components": "static-1.6479",
      "customer-data-sidebar": "static-2.45718",
      "enrichment-properties-lib": "static-1.15544",
      "commerce-billing-lib": "static-1.18791",
      "commerce-shared-components-lib": "static-1.18257",
      "commerce-tools-ui-lib": "static-1.10102",
      "directed-graph": "static-1.834",
      "event-emitter": "static-1.845",
      "fast-json-patch": "static-1.61",
      "customer-data-associations": "static-1.7221",
      "deal-intel-decorators": "static-1.1637",
      "reporting-data": "static-1.67010",
      "tanstack-virtual": "static-1.28",
      "ui-addon-draggable": "static-3.4666",
      "crm-record-cards-service-types": "static-1.3526",
      "self-service-api": "static-1.10142",
      "crm_universal": "static-1.21825",
      "SalesContentIndexUI": "static-3.9082",
      "content-embed-lib": "static-1.7237",
      "data-model-builder-lib": "static-1.11996",
      "remote-ui": "static-1.63",
      "ui-components-test-utils": "static-1.5487",
      "ui-extensions-remote-renderer": "static-1.16688",
      "universal-page-editor-lib": "static-1.2903",
      "integrations-error-boundary-lib": "static-1.13191",
      "redux-observable": "static-1.11",
      "ReduxMessenger": "static-2.10271",
      "rxjs": "static-5.10",
      "unified-auth": "static-1.345",
      "messaging-types-lib": "static-1.45677",
      "data-token-picker": "static-1.16223",
      "sequences-client-types-lib": "static-1.7719",
      "foundations-components-test-utils": "static-1.5200",
      "navigation-messaging": "static-1.6971",
      "getting-started-shared-tasks": "static-1.18202",
      "getting-started-shared-tasks-store": "static-1.17320",
      "onboarding-tours-utils": "static-1.479",
      "messaging-usage-based-billing-components-lib": "static-1.802",
      "whatsapp-management-lib": "static-1.8480",
      "growth-data-modal": "static-1.5270",
      "growth-onboarding-confetti": "static-1.2968",
      "growth-onboarding-next-action-utils": "static-1.1609",
      "navigation-components": "static-1.17644",
      "onboarding-tours-client": "static-1.4627",
      "ui-shepherd-tracker": "static-1.7425",
      "shared-worker-versioning": "static-1.10935",
      "voice-sms-access-library": "static-1.592",
      "commerce-permissions": "static-1.662",
      "products-iframe-lib": "static-1.7637",
      "products-ui-components-shared-msw-handlers": "static-1.10107",
      "data-agent-kit": "static-1.28",
      "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9808",
      "fsm": "static-1.3630",
      "policy-lib": "static-1.6679",
      "react-tinymce": "static-1.54939",
      "tinymce": "static-5.11",
      "tinymce-config": "static-2.54065",
      "tinymce-plugins": "static-1.57179",
      "tinymce-themes": "static-1.56035",
      "content-media-composition-data-lib": "static-1.11894",
      "content-media-compositions": "static-2.15901",
      "idb-keyval": "static-1.42",
      "media-bridge-lib": "static-1.18743",
      "ui-addon-opt": "static-4.8279",
      "commerce-tours-lib": "static-1.5904",
      "growth-onboarding-reliability": "static-1.4983",
      "sales-checkout-service-client": "static-1.3565",
      "ai-addon-copilot-preview": "static-1.7886",
      "calling-cross-tab-library": "static-1.19171",
      "calling-lifecycle-usage-tracker": "static-1.8428",
      "wootric-nps": "static-1.6881",
      "growth-monetization-service-types": "static-1.4399",
      "nav-client-types": "static-1.2255",
      "purchase-motions-api": "static-1.5680",
      "trials-service-types": "static-1.3800",
      "reactive-lib": "static-1.621",
      "card-payment-highlight-lib": "static-1.36845",
      "card-subscription-highlight-lib": "static-1.39216",
      "commerce-contract-lib": "static-1.11600",
      "invoices-highlight-card-lib": "static-1.54371",
      "orders-highlight-card-lib": "static-1.21169",
      "products-highlight-card-lib": "static-1.17433",
      "quotes-highlight-card-lib": "static-1.71596",
      "usage-based-billing-components-lib": "static-1.8323",
      "utility-belt": "static-1.2437",
      "payments-enrollment-embed-lib": "static-1.22332",
      "stripe-embedded-components": "static-1.7322",
      "growth-onboarding-empty-states": "static-1.5528",
      "InboxConnectUtils": "static-4.14522",
      "payments-post-enroll-local-storage-lib": "static-1.5008",
      "qrcode-generator": "static-1.67",
      "deal-intel-utils": "static-1.1641",
      "storybook-react": "static-1.31",
      "reporting-client-types": "static-1.2427",
      "react-flip-move": "static-1.68",
      "FireAlarmUi": "static-1.4426",
      "sales-templates-service-types-lib": "static-1.4083",
      "ui-asset-management-lib": "static-1.10878",
      "association-settings-lib": "static-1.9991",
      "collaboration-sidebar": "static-1.57469",
      "conditional-property-settings-modal": "static-1.12225",
      "data-model-commons-lib": "static-1.12267",
      "nudge-client-utils": "static-1.2357",
      "final-form": "static-1.68",
      "html-to-image": "static-1.52",
      "object-definition-builder-lib": "static-1.6977",
      "property-management-iframe": "static-1.12800",
      "property-usages-lib": "static-1.5306",
      "reactflow": "static-1.62",
      "simple-data-table": "static-1.2486",
      "used-in-list-lib": "static-1.6832",
      "visual-association": "static-1.5761",
      "highcharts": "static-8.102",
      "reporting-visualizations": "static-1.59086",
      "ui-extensibility-client-types": "static-1.3836",
      "automation-platform-service-types": "static-1.2552",
      "ContentData": "static-1.68110",
      "email-portal-health-service-types": "static-1.873",
      "marketing-email-service-types": "static-1.1837",
      "messaging-shared-utils-lib": "static-1.251",
      "messaging-user-info-utils-lib": "static-1.421",
      "content-whatsapp-service-types": "static-1.301",
      "marketing-platform-lib": "static-1.6746",
      "short-messages-app-service-client": "static-1.3878",
      "ui-tool-access": "static-1.10044",
      "onboarding-data-sync-lib": "static-1.1787",
      "growth-onboarding-next-action-components": "static-1.1637",
      "user-context-client": "static-1.4509",
      "nest": "static-1.119",
      "calling-orchestration-schema": "static-1.35369",
      "sales-views-client-types": "static-1.4160",
      "trellis-story-utils": "static-1.4416",
      "hub-http-contrib": "static-1.2940",
      "interframe": "static-3.4660",
      "tinymce-data": "static-1.40150",
      "ui-addon-sales-email": "static-1.5108",
      "codemirror": "static-5.93",
      "layout-dnd-components": "static-1.12243",
      "layout-dnd-utils": "static-1.11218",
      "react-codemirror": "static-1.10521",
      "ui-brand-identity-lib": "static-1.14776",
      "NamespacedHubStyle": "static-2.8985",
      "js-cookie": "static-1.18",
      "ai-rendering-library": "static-1.9703",
      "ai-settings-ui-library": "static-1.7717",
      "copilot-plugins": "static-1.10810",
      "eligibility-engine-service-types": "static-1.3081",
      "products-ui-components": "static-1.39668",
      "quotes-ui-lib": "static-1.80317",
      "zustand": "static-1.51",
      "accounting-integrations-ui-components": "static-1.6895",
      "invoices-ui-lib": "static-1.54387",
      "commerce-products-api": "static-1.2135",
      "invoices-iframe-lib": "static-1.56445",
      "quotes-modal-lib": "static-1.102274",
      "platform-infra-nav-components": "static-1.7582",
      "reporting-ui-components": "static-2.64281",
      "subscription-experience-data-types": "static-1.14735",
      "marketplace-ui-apps-core": "static-1.17827",
      "stripe-connect-js": "static-1.66",
      "ui-addon-react-router-dom": "static-1.9441",
      "nested-table": "static-1.119",
      "association-translator": "static-1.3081",
      "crm-settings-header-lib": "static-1.8231",
      "settings-ui-nav": "static-2.10084",
      "chatspot-widget-iframe": "static-1.20791",
      "collaboration-sidebar-common": "static-1.2266",
      "crm-properties-common-lib": "static-1.5772",
      "ui-addon-draggable-compat": "static-2.4151",
      "nudge-custom-function-registry": "static-1.2114",
      "nudge-renderer-utils": "static-1.2433",
      "whisper-core-api": "static-1.6299",
      "property-management-common": "static-1.5088",
      "d3": "static-1.7",
      "advanced-menus-core": "static-1.14968",
      "advanced-menus-lib": "static-1.11930",
      "ExportDialog": "static-6.10288",
      "ui-memberships-settings-lib": "static-1.33756",
      "diff-match-patch": "static-1.7",
      "layout-data-lib": "static-1.9543",
      "browser-eslint": "static-2.57",
      "embedded-academy-lib": "static-1.13946",
      "highlight.js": "static-1.77",
      "reporting-action-components": "static-1.40968",
      "reporting-snowflake": "static-1.55628",
      "commerce-tax-lib": "static-1.416",
      "property-description-translator": "static-1.3750",
      "commerce-analytics-service-client": "static-1.3553",
      "totals-ui-components": "static-1.23293",
      "reporting-plugins": "static-1.10133",
      "reporting-reports": "static-1.66688",
      "edison-service-client-types": "static-1.284",
      "developer-experience-shared-components": "static-1.10404",
      "marketplace-ui-client-types": "static-1.16701",
      "marketplace-ui-common": "static-1.19294",
      "ui-addon-integrations-directory-panel": "static-2.7888",
      "react-window": "static-1.13",
      "seamless-immutable": "static-7.6",
      "simple-menus-core": "static-1.14967",
      "simple-menus-lib": "static-1.16484",
      "academy-common-lib": "static-1.13406",
      "dashboard-lib": "static-1.81088",
      "share-with-third-party-component-lib": "static-1.8592",
      "commerce-totals-service-types": "static-1.3734",
      "campaign-roi-lib": "static-1.8632",
      "apps-service-types": "static-1.3774",
      "oauth-service-types": "static-1.4146",
      "academy-service-client": "static-1.3578",
      "redux-actions": "static-3.7"
    },
    "depPathPrefixes": {
      "conversations-visitor-ui": "/conversations-visitor-ui/static-1.28763",
      "ably": "/ably/static-2.2",
      "data-fetching-client": "/data-fetching-client/static-1.9572",
      "ably-hubspot-js": "/ably-hubspot-js/static-2.4611",
      "atom": "/atom/static-1.4968",
      "conversations-async-data": "/conversations-async-data/static-2.7562",
      "conversations-error-reporting": "/conversations-error-reporting/static-1.8775",
      "conversations-internal-pub-sub": "/conversations-internal-pub-sub/static-1.15866",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.12666",
      "conversations-message-history": "/conversations-message-history/static-1.12361",
      "conversations-test-sdk": "/conversations-test-sdk/static-1.10397",
      "conversations-visitor-experience-components": "/conversations-visitor-experience-components/static-1.22126",
      "head-dlb": "/head-dlb/static-1.4921",
      "hs-promise-utils": "/hs-promise-utils/static-1.5491",
      "hs-test-utils": "/hs-test-utils/static-1.7908",
      "hubspot-dlb": "/hubspot-dlb/static-2.1828",
      "HubStyleTokens": "/HubStyleTokens/static-2.11349",
      "I18n": "/I18n/static-7.1602",
      "immer": "/immer/static-1.33",
      "jasmine-immutable": "/jasmine-immutable/static-1.2914",
      "jasmine-runner": "/jasmine-runner/static-1.6366",
      "quartz": "/quartz/static-1.6864",
      "react-dlb": "/react-dlb/static-1.76",
      "react-select-plus": "/react-select-plus/static-1.65",
      "react-transition-group": "/react-transition-group/static-2.63",
      "redux-thunk": "/redux-thunk/static-2.43",
      "sanitize": "/sanitize/static-1.4370",
      "StyleGuideUI": "/StyleGuideUI/static-3.485",
      "transmute": "/transmute/static-2.85",
      "urlinator": "/urlinator/static-1.4429",
      "usage-tracker": "/usage-tracker/static-1.7233",
      "usage-tracker-core": "/usage-tracker-core/static-1.7083",
      "usage-tracker-public": "/usage-tracker-public/static-1.7044",
      "viral-links-lib": "/viral-links-lib/static-1.6938",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.6033",
      "webpack-env": "/webpack-env/static-1.54",
      "autolinker": "/autolinker/static-3.11",
      "classnames": "/classnames/static-2.10",
      "conversations-http": "/conversations-http/static-1.4705",
      "conversations-prop-types": "/conversations-prop-types/static-1.7350",
      "conversations-visitor-message-history": "/conversations-visitor-message-history/static-1.20863",
      "cssUtils": "/cssUtils/static-1.768",
      "enviro": "/enviro/static-4.425",
      "flux-actions": "/flux-actions/static-1.325",
      "foundations-components": "/foundations-components/static-1.7717",
      "hs-lodash": "/hs-lodash/static-4.45",
      "hub-http": "/hub-http/static-1.6116",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.4034",
      "immutable": "/immutable/static-2.76",
      "metrics-js": "/metrics-js/static-1.9522",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "PortalIdParser": "/PortalIdParser/static-2.386",
      "raven": "/raven/static-3.5808",
      "react": "/react/static-7.184",
      "react-aria": "/react-aria/static-1.64",
      "react-dom": "/react-dom/static-7.85",
      "react-redux": "/react-redux/static-7.69",
      "react-rhumb": "/react-rhumb/static-1.16552",
      "react-utils": "/react-utils/static-2.5264",
      "redux": "/redux/static-4.16",
      "redux-toolkit": "/redux-toolkit/static-1.7",
      "reselect": "/reselect/static-2.16",
      "sanitize-text": "/sanitize-text/static-1.8042",
      "signup-constants": "/signup-constants/static-1.18652",
      "styled-components": "/styled-components/static-2.87",
      "usage-tracker-multi": "/usage-tracker-multi/static-1.5647",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.5844",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5473",
      "raven-hubspot": "/raven-hubspot/static-1.6115",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3322",
      "moment": "/moment/static-3.26",
      "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
      "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
      "graphql": "/graphql/static-1.80",
      "quartz-config": "/quartz-config/static-1.642",
      "quartz-core": "/quartz-core/static-1.6083",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "foundations-assets": "/foundations-assets/static-1.4744",
      "foundations-theming": "/foundations-theming/static-1.4310",
      "UIComponents": "/UIComponents/static-3.8296",
      "customer-data-email": "/customer-data-email/static-1.17853",
      "cv-backend-services": "/cv-backend-services/static-1.1537",
      "immutable-less": "/immutable-less/static-1.4550",
      "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7146",
      "crm-events-viz-core": "/crm-events-viz-core/static-1.32830",
      "customer-data-objects": "/customer-data-objects/static-1.7553",
      "icons": "/icons/static-2.639",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "rpc-client-utils": "/rpc-client-utils/static-1.4541",
      "ui-images": "/ui-images/static-2.1128",
      "HeadJS": "/HeadJS/static-2.735",
      "framer-motion": "/framer-motion/static-1.70",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3019",
      "msw": "/msw/static-1.39",
      "testing-library": "/testing-library/static-1.150",
      "i18n-data": "/i18n-data/static-1.219",
      "moment-timezone": "/moment-timezone/static-5.81",
      "jasmine": "/jasmine/static-4.4221",
      "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7938",
      "HubStyle": "/HubStyle/static-2.11657",
      "quartz-i18n": "/quartz-i18n/static-1.539",
      "sassPrefix": "/sassPrefix/static-1.154",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3986",
      "floating-ui": "/floating-ui/static-1.54",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2026",
      "hs-story-utils": "/hs-story-utils/static-1.9327",
      "react-virtualized": "/react-virtualized/static-2.97",
      "tanstack-table": "/tanstack-table/static-1.53",
      "trellis-assets": "/trellis-assets/static-1.1523",
      "ui-fonts": "/ui-fonts/static-1.611",
      "csstype": "/csstype/static-1.50",
      "quick-fetch": "/quick-fetch/static-1.3832",
      "history": "/history/static-4.47",
      "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5650",
      "bender-build-tools": "/bender-build-tools/static-1.3063",
      "dispatcher": "/dispatcher/static-1.134",
      "general-store": "/general-store/static-6.20",
      "hub-http-janus": "/hub-http-janus/static-1.819",
      "hubspotter-http": "/hubspotter-http/static-1.4568",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.508",
      "module-federation": "/module-federation/static-1.21",
      "quartz-auth": "/quartz-auth/static-1.539",
      "quartz-head": "/quartz-head/static-1.529",
      "quartz-routing": "/quartz-routing/static-1.294",
      "quartz-test": "/quartz-test/static-1.539",
      "quartz-tracking": "/quartz-tracking/static-1.243",
      "usage-tracker-container": "/usage-tracker-container/static-1.7223",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2793",
      "foundations-theming-base": "/foundations-theming-base/static-1.3295",
      "stylex": "/stylex/static-1.30",
      "apollo-dlb": "/apollo-dlb/static-3.80",
      "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4548",
      "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9722",
      "FileManagerCore": "/FileManagerCore/static-1.38788",
      "FileManagerLib": "/FileManagerLib/static-1.38929",
      "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4775",
      "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
      "salesImages": "/salesImages/static-1.523",
      "timezone-utils": "/timezone-utils/static-2.5141",
      "ui-gdpr-components": "/ui-gdpr-components/static-1.10245",
      "ts-schema": "/ts-schema/static-1.3994",
      "ai-components-ui-library": "/ai-components-ui-library/static-1.8674",
      "avatar-components": "/avatar-components/static-1.2391",
      "content-assistance-lib": "/content-assistance-lib/static-1.7598",
      "crm-component-utils": "/crm-component-utils/static-1.38783",
      "crm-display-components": "/crm-display-components/static-1.24533",
      "crm-fe-perf": "/crm-fe-perf/static-1.22800",
      "crm-links": "/crm-links/static-1.6172",
      "crm-message-bus": "/crm-message-bus/static-1.42694",
      "crm-search-service-types": "/crm-search-service-types/static-1.1048",
      "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5231",
      "customer-data-communicator": "/customer-data-communicator/static-1.45203",
      "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39347",
      "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12915",
      "customer-data-properties": "/customer-data-properties/static-1.51179",
      "customer-data-rte": "/customer-data-rte/static-1.32726",
      "draft-plugins": "/draft-plugins/static-2.21492",
      "file-manager-components": "/file-manager-components/static-1.23289",
      "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6772",
      "frontend-preferences-client": "/frontend-preferences-client/static-1.7821",
      "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17936",
      "object-comments-thread-lib": "/object-comments-thread-lib/static-1.10381",
      "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7986",
      "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17839",
      "universal-associations-select": "/universal-associations-select/static-1.10906",
      "universal-record-utils-lib": "/universal-record-utils-lib/static-1.568",
      "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3762",
      "property-translator": "/property-translator/static-1.5305",
      "chirp-fetch": "/chirp-fetch/static-1.1778",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9725",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9723",
      "react-router-dom": "/react-router-dom/static-5.26",
      "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4919",
      "react-dnd-compat": "/react-dnd-compat/static-1.4515",
      "audio-components": "/audio-components/static-1.5760",
      "cropperjs": "/cropperjs/static-1.10",
      "feedback-loader": "/feedback-loader/static-1.29103",
      "FileManagerImages": "/FileManagerImages/static-1.36440",
      "foundations-components-legacy": "/foundations-components-legacy/static-1.742",
      "immerable": "/immerable/static-1.4050",
      "ui-universal-auth": "/ui-universal-auth/static-1.8831",
      "video-components": "/video-components/static-1.12943",
      "video-data-lib": "/video-data-lib/static-1.34598",
      "video-embed": "/video-embed/static-1.35432",
      "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.234",
      "chatspot-core": "/chatspot-core/static-1.20799",
      "ContentUtils": "/ContentUtils/static-1.68035",
      "copilot-toolkit": "/copilot-toolkit/static-1.10837",
      "superstore": "/superstore/static-1.4666",
      "ui-addon-video-player": "/ui-addon-video-player/static-1.8593",
      "ui-coaching-tips": "/ui-coaching-tips/static-1.28249",
      "card-properties-lib": "/card-properties-lib/static-1.43858",
      "commerce-subscription-lib": "/commerce-subscription-lib/static-1.36793",
      "crm-actions": "/crm-actions/static-1.6211",
      "crm-cards-sdk": "/crm-cards-sdk/static-1.43266",
      "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9052",
      "customer-data-property-utils": "/customer-data-property-utils/static-1.7980",
      "customer-data-tracking": "/customer-data-tracking/static-1.6781",
      "hs-resources": "/hs-resources/static-1.35",
      "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3505",
      "pulse": "/pulse/static-1.437",
      "framework-data-table": "/framework-data-table/static-2.11673",
      "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8912",
      "calling-error-reporting": "/calling-error-reporting/static-1.31204",
      "calling-internal-common": "/calling-internal-common/static-1.31198",
      "calling-usage-tracker": "/calling-usage-tracker/static-1.6438",
      "crm_data": "/crm_data/static-4.91623",
      "customer-data-content": "/customer-data-content/static-1.27085",
      "draft-content-plugins": "/draft-content-plugins/static-1.27993",
      "draft-convert": "/draft-convert/static-2.71",
      "draft-extend": "/draft-extend/static-3.73",
      "draft-js": "/draft-js/static-5.76",
      "draft-signature-plugin": "/draft-signature-plugin/static-1.23795",
      "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24146",
      "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17928",
      "integration-settings-components": "/integration-settings-components/static-1.15152",
      "integrations-lib": "/integrations-lib/static-1.15776",
      "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5492",
      "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7683",
      "nav-meta": "/nav-meta/static-1.29281",
      "onboarding-scopes": "/onboarding-scopes/static-1.6361",
      "outreach-assistant-email-generation": "/outreach-assistant-email-generation/static-1.6010",
      "prosemirror": "/prosemirror/static-1.13",
      "quotes-client-types": "/quotes-client-types/static-1.37686",
      "react-colorpicker": "/react-colorpicker/static-2.10106",
      "reference-resolvers": "/reference-resolvers/static-1.8064",
      "rich-text-lib": "/rich-text-lib/static-1.19652",
      "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3740",
      "sequences-lib": "/sequences-lib/static-1.7862",
      "ui-addon-i18n": "/ui-addon-i18n/static-1.11044",
      "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8946",
      "ui-business-units-lib": "/ui-business-units-lib/static-1.8937",
      "ui-shepherd-react": "/ui-shepherd-react/static-3.10044",
      "user-context": "/user-context/static-1.4997",
      "whatsapp-sending-lib": "/whatsapp-sending-lib/static-1.5321",
      "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21782",
      "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13050",
      "FormUrlGenerator": "/FormUrlGenerator/static-2.4616",
      "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3924",
      "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6677",
      "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.873",
      "onboarding-tours": "/onboarding-tours/static-1.16413",
      "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13378",
      "SharedI18nStrings": "/SharedI18nStrings/static-1.181",
      "ui-addon-teams": "/ui-addon-teams/static-1.21407",
      "calling-global-api": "/calling-global-api/static-1.64094",
      "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65476",
      "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57770",
      "commerce-products-lib": "/commerce-products-lib/static-1.9149",
      "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3713",
      "external-options-client-types": "/external-options-client-types/static-1.4074",
      "google-libphonenumber": "/google-libphonenumber/static-1.36",
      "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4139",
      "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.527",
      "multi-currency-client-types": "/multi-currency-client-types/static-1.3606",
      "object-builder-ui-client": "/object-builder-ui-client/static-1.48387",
      "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3881",
      "property-value-citations": "/property-value-citations/static-1.1793",
      "smart-property-lib": "/smart-property-lib/static-1.6426",
      "tiered-pricing": "/tiered-pricing/static-1.1009",
      "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10888",
      "video-components-external": "/video-components-external/static-1.10940",
      "batch-promise": "/batch-promise/static-1.1449",
      "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4058",
      "persist-promise": "/persist-promise/static-1.3606",
      "emoji-mart": "/emoji-mart/static-3.4",
      "growth-payments-core": "/growth-payments-core/static-1.25054",
      "knowledge-content-types": "/knowledge-content-types/static-1.8441",
      "payment-link-components": "/payment-link-components/static-1.23237",
      "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9784",
      "call-summary": "/call-summary/static-1.38784",
      "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9871",
      "laboratory-lib": "/laboratory-lib/static-3.7056",
      "merchandise-lib": "/merchandise-lib/static-1.261",
      "purchase-motions-components": "/purchase-motions-components/static-1.5677",
      "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.9340",
      "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.58",
      "react-dnd": "/react-dnd/static-5.6",
      "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
      "unified-auth-core-lib": "/unified-auth-core-lib/static-1.626",
      "content-icons-ui": "/content-icons-ui/static-1.2201",
      "social-insights-client-types": "/social-insights-client-types/static-1.21775",
      "outpost": "/outpost/static-1.4092",
      "markdown-it": "/markdown-it/static-1.6",
      "cms-field-types": "/cms-field-types/static-1.4706",
      "underscore": "/underscore/static-1.8",
      "magpie-lib": "/magpie-lib/static-1.5490",
      "magpie-types": "/magpie-types/static-1.4950",
      "simple-logging-lib": "/simple-logging-lib/static-1.2948",
      "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6479",
      "customer-data-sidebar": "/customer-data-sidebar/static-2.45718",
      "enrichment-properties-lib": "/enrichment-properties-lib/static-1.15544",
      "commerce-billing-lib": "/commerce-billing-lib/static-1.18791",
      "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18257",
      "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.10102",
      "directed-graph": "/directed-graph/static-1.834",
      "event-emitter": "/event-emitter/static-1.845",
      "fast-json-patch": "/fast-json-patch/static-1.61",
      "customer-data-associations": "/customer-data-associations/static-1.7221",
      "deal-intel-decorators": "/deal-intel-decorators/static-1.1637",
      "reporting-data": "/reporting-data/static-1.67010",
      "tanstack-virtual": "/tanstack-virtual/static-1.28",
      "ui-addon-draggable": "/ui-addon-draggable/static-3.4666",
      "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3526",
      "self-service-api": "/self-service-api/static-1.10142",
      "crm_universal": "/crm_universal/static-1.21825",
      "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9082",
      "content-embed-lib": "/content-embed-lib/static-1.7237",
      "data-model-builder-lib": "/data-model-builder-lib/static-1.11996",
      "remote-ui": "/remote-ui/static-1.63",
      "ui-components-test-utils": "/ui-components-test-utils/static-1.5487",
      "ui-extensions-remote-renderer": "/ui-extensions-remote-renderer/static-1.16688",
      "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2903",
      "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13191",
      "redux-observable": "/redux-observable/static-1.11",
      "ReduxMessenger": "/ReduxMessenger/static-2.10271",
      "rxjs": "/rxjs/static-5.10",
      "unified-auth": "/unified-auth/static-1.345",
      "messaging-types-lib": "/messaging-types-lib/static-1.45677",
      "data-token-picker": "/data-token-picker/static-1.16223",
      "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7719",
      "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5200",
      "navigation-messaging": "/navigation-messaging/static-1.6971",
      "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18202",
      "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17320",
      "onboarding-tours-utils": "/onboarding-tours-utils/static-1.479",
      "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.802",
      "whatsapp-management-lib": "/whatsapp-management-lib/static-1.8480",
      "growth-data-modal": "/growth-data-modal/static-1.5270",
      "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2968",
      "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1609",
      "navigation-components": "/navigation-components/static-1.17644",
      "onboarding-tours-client": "/onboarding-tours-client/static-1.4627",
      "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7425",
      "shared-worker-versioning": "/shared-worker-versioning/static-1.10935",
      "voice-sms-access-library": "/voice-sms-access-library/static-1.592",
      "commerce-permissions": "/commerce-permissions/static-1.662",
      "products-iframe-lib": "/products-iframe-lib/static-1.7637",
      "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10107",
      "data-agent-kit": "/data-agent-kit/static-1.28",
      "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9808",
      "fsm": "/fsm/static-1.3630",
      "policy-lib": "/policy-lib/static-1.6679",
      "react-tinymce": "/react-tinymce/static-1.54939",
      "tinymce": "/tinymce/static-5.11",
      "tinymce-config": "/tinymce-config/static-2.54065",
      "tinymce-plugins": "/tinymce-plugins/static-1.57179",
      "tinymce-themes": "/tinymce-themes/static-1.56035",
      "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11894",
      "content-media-compositions": "/content-media-compositions/static-2.15901",
      "idb-keyval": "/idb-keyval/static-1.42",
      "media-bridge-lib": "/media-bridge-lib/static-1.18743",
      "ui-addon-opt": "/ui-addon-opt/static-4.8279",
      "commerce-tours-lib": "/commerce-tours-lib/static-1.5904",
      "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4983",
      "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3565",
      "ai-addon-copilot-preview": "/ai-addon-copilot-preview/static-1.7886",
      "calling-cross-tab-library": "/calling-cross-tab-library/static-1.19171",
      "calling-lifecycle-usage-tracker": "/calling-lifecycle-usage-tracker/static-1.8428",
      "wootric-nps": "/wootric-nps/static-1.6881",
      "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4399",
      "nav-client-types": "/nav-client-types/static-1.2255",
      "purchase-motions-api": "/purchase-motions-api/static-1.5680",
      "trials-service-types": "/trials-service-types/static-1.3800",
      "reactive-lib": "/reactive-lib/static-1.621",
      "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.36845",
      "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.39216",
      "commerce-contract-lib": "/commerce-contract-lib/static-1.11600",
      "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.54371",
      "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.21169",
      "products-highlight-card-lib": "/products-highlight-card-lib/static-1.17433",
      "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.71596",
      "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.8323",
      "utility-belt": "/utility-belt/static-1.2437",
      "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.22332",
      "stripe-embedded-components": "/stripe-embedded-components/static-1.7322",
      "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5528",
      "InboxConnectUtils": "/InboxConnectUtils/static-4.14522",
      "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5008",
      "qrcode-generator": "/qrcode-generator/static-1.67",
      "deal-intel-utils": "/deal-intel-utils/static-1.1641",
      "storybook-react": "/storybook-react/static-1.31",
      "reporting-client-types": "/reporting-client-types/static-1.2427",
      "react-flip-move": "/react-flip-move/static-1.68",
      "FireAlarmUi": "/FireAlarmUi/static-1.4426",
      "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4083",
      "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10878",
      "association-settings-lib": "/association-settings-lib/static-1.9991",
      "collaboration-sidebar": "/collaboration-sidebar/static-1.57469",
      "conditional-property-settings-modal": "/conditional-property-settings-modal/static-1.12225",
      "data-model-commons-lib": "/data-model-commons-lib/static-1.12267",
      "nudge-client-utils": "/nudge-client-utils/static-1.2357",
      "final-form": "/final-form/static-1.68",
      "html-to-image": "/html-to-image/static-1.52",
      "object-definition-builder-lib": "/object-definition-builder-lib/static-1.6977",
      "property-management-iframe": "/property-management-iframe/static-1.12800",
      "property-usages-lib": "/property-usages-lib/static-1.5306",
      "reactflow": "/reactflow/static-1.62",
      "simple-data-table": "/simple-data-table/static-1.2486",
      "used-in-list-lib": "/used-in-list-lib/static-1.6832",
      "visual-association": "/visual-association/static-1.5761",
      "highcharts": "/highcharts/static-8.102",
      "reporting-visualizations": "/reporting-visualizations/static-1.59086",
      "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3836",
      "automation-platform-service-types": "/automation-platform-service-types/static-1.2552",
      "ContentData": "/ContentData/static-1.68110",
      "email-portal-health-service-types": "/email-portal-health-service-types/static-1.873",
      "marketing-email-service-types": "/marketing-email-service-types/static-1.1837",
      "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.251",
      "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.421",
      "content-whatsapp-service-types": "/content-whatsapp-service-types/static-1.301",
      "marketing-platform-lib": "/marketing-platform-lib/static-1.6746",
      "short-messages-app-service-client": "/short-messages-app-service-client/static-1.3878",
      "ui-tool-access": "/ui-tool-access/static-1.10044",
      "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.1787",
      "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1637",
      "user-context-client": "/user-context-client/static-1.4509",
      "nest": "/nest/static-1.119",
      "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35369",
      "sales-views-client-types": "/sales-views-client-types/static-1.4160",
      "trellis-story-utils": "/trellis-story-utils/static-1.4416",
      "hub-http-contrib": "/hub-http-contrib/static-1.2940",
      "interframe": "/interframe/static-3.4660",
      "tinymce-data": "/tinymce-data/static-1.40150",
      "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5108",
      "codemirror": "/codemirror/static-5.93",
      "layout-dnd-components": "/layout-dnd-components/static-1.12243",
      "layout-dnd-utils": "/layout-dnd-utils/static-1.11218",
      "react-codemirror": "/react-codemirror/static-1.10521",
      "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.14776",
      "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8985",
      "js-cookie": "/js-cookie/static-1.18",
      "ai-rendering-library": "/ai-rendering-library/static-1.9703",
      "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7717",
      "copilot-plugins": "/copilot-plugins/static-1.10810",
      "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3081",
      "products-ui-components": "/products-ui-components/static-1.39668",
      "quotes-ui-lib": "/quotes-ui-lib/static-1.80317",
      "zustand": "/zustand/static-1.51",
      "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.6895",
      "invoices-ui-lib": "/invoices-ui-lib/static-1.54387",
      "commerce-products-api": "/commerce-products-api/static-1.2135",
      "invoices-iframe-lib": "/invoices-iframe-lib/static-1.56445",
      "quotes-modal-lib": "/quotes-modal-lib/static-1.102274",
      "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7582",
      "reporting-ui-components": "/reporting-ui-components/static-2.64281",
      "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14735",
      "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.17827",
      "stripe-connect-js": "/stripe-connect-js/static-1.66",
      "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9441",
      "nested-table": "/nested-table/static-1.119",
      "association-translator": "/association-translator/static-1.3081",
      "crm-settings-header-lib": "/crm-settings-header-lib/static-1.8231",
      "settings-ui-nav": "/settings-ui-nav/static-2.10084",
      "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.20791",
      "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.2266",
      "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5772",
      "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4151",
      "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2114",
      "nudge-renderer-utils": "/nudge-renderer-utils/static-1.2433",
      "whisper-core-api": "/whisper-core-api/static-1.6299",
      "property-management-common": "/property-management-common/static-1.5088",
      "d3": "/d3/static-1.7",
      "advanced-menus-core": "/advanced-menus-core/static-1.14968",
      "advanced-menus-lib": "/advanced-menus-lib/static-1.11930",
      "ExportDialog": "/ExportDialog/static-6.10288",
      "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33756",
      "diff-match-patch": "/diff-match-patch/static-1.7",
      "layout-data-lib": "/layout-data-lib/static-1.9543",
      "browser-eslint": "/browser-eslint/static-2.57",
      "embedded-academy-lib": "/embedded-academy-lib/static-1.13946",
      "highlight.js": "/highlight.js/static-1.77",
      "reporting-action-components": "/reporting-action-components/static-1.40968",
      "reporting-snowflake": "/reporting-snowflake/static-1.55628",
      "commerce-tax-lib": "/commerce-tax-lib/static-1.416",
      "property-description-translator": "/property-description-translator/static-1.3750",
      "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3553",
      "totals-ui-components": "/totals-ui-components/static-1.23293",
      "reporting-plugins": "/reporting-plugins/static-1.10133",
      "reporting-reports": "/reporting-reports/static-1.66688",
      "edison-service-client-types": "/edison-service-client-types/static-1.284",
      "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10404",
      "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.16701",
      "marketplace-ui-common": "/marketplace-ui-common/static-1.19294",
      "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7888",
      "react-window": "/react-window/static-1.13",
      "seamless-immutable": "/seamless-immutable/static-7.6",
      "simple-menus-core": "/simple-menus-core/static-1.14967",
      "simple-menus-lib": "/simple-menus-lib/static-1.16484",
      "academy-common-lib": "/academy-common-lib/static-1.13406",
      "dashboard-lib": "/dashboard-lib/static-1.81088",
      "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8592",
      "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3734",
      "campaign-roi-lib": "/campaign-roi-lib/static-1.8632",
      "apps-service-types": "/apps-service-types/static-1.3774",
      "oauth-service-types": "/oauth-service-types/static-1.4146",
      "academy-service-client": "/academy-service-client/static-1.3578",
      "redux-actions": "/redux-actions/static-3.7"
    },
    "bundlingPackage": "conversations-visitor-ui",
    "bundlingPackageVersion": "static-1.28763",
    "project": "conversations-visitor-ui",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};